function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#cm)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M88.6541 271.431L27.504 204.549L-95.542 382.714L-233.861 419.914L-227.326 522.914L-198.887 499.52C23.651 550.149 88.6541 271.431 88.6541 271.431Z",
  fill: "#E4AB4E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-5.40193 445.028C9.17407 392.964 0.764067 346.028 -29.4539 330.542C-37.6929 326.426 -46.9233 324.711 -56.0909 325.591L-95.5419 382.714L-150.428 397.476C-154.302 403.576 -157.979 409.976 -161.409 416.667C-176.487 446.083 -184.359 476.116 -185.232 502.245C-105.772 515.93 -47.3619 486.779 -5.40193 445.028Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.112 238.32C82.112 238.32 -21.656 475.462 -117.24 563.928L-115.188 580.398L-185.954 544.125C-185.954 544.125 -43.782 247.715 -11.427 184.594L82.112 238.32Z",
  fill: "#FFC85C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.003 103.763L-11.427 184.594L88.653 271.432L134.797 181.411C142.749 165.899 145.27 148.169 141.957 131.056C138.644 113.943 129.688 98.4345 116.522 87.0111V87.0111C110.109 81.4472 102.516 77.4144 94.3147 75.2178C86.1139 73.0212 77.5209 72.7184 69.1858 74.3323C60.8507 75.9462 52.9918 79.4344 46.2035 84.5332C39.4152 89.632 33.8753 96.2078 30.003 103.763V103.763Z",
  fill: "#EE5998"
}), /*#__PURE__*/React.createElement("path", {
  d: "M82.113 238.32C82.113 238.32 -21.653 475.462 -117.239 563.928",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.1371 106.835C34.1371 106.835 37.5911 238.353 215.196 187.325C219.963 185.956 224.239 183.251 227.519 179.53C230.798 175.808 232.945 171.227 233.704 166.325L235.532 154.525L251.084 146.561L247.947 139.761L222.242 141.161L132.942 146.032L104.774 88.5321",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.2951 116.813C35.2951 116.813 14.0631 229.124 140.677 199.084H140.684C57.8891 198.616 39.396 140.582 35.2951 116.813Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M120.412 90.197L150.973 123.824L225.021 57.024C229.399 53.0744 234.863 50.5311 240.704 49.7241L251.082 48.29V54.04L238.536 58.7401L243.417 75.525C244.338 78.6854 244.36 82.0399 243.48 85.212C240.897 94.524 234.227 115.312 221.632 135.234",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.603 35.3291L143.638 68.6741L101.126 73.9141L107.817 17.6471L150.329 12.4071L147.603 35.3291Z",
  fill: "#FFE1B6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M123.03 44.098C123.644 44.098 124.142 43.6002 124.142 42.986C124.142 42.3719 123.644 41.874 123.03 41.874C122.416 41.874 121.918 42.3719 121.918 42.986C121.918 43.6002 122.416 44.098 123.03 44.098Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.993 46.1151C140.607 46.1151 141.105 45.6173 141.105 45.0031C141.105 44.389 140.607 43.8911 139.993 43.8911C139.379 43.8911 138.881 44.389 138.881 45.0031C138.881 45.6173 139.379 46.1151 139.993 46.1151Z",
  fill: "#131313"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.233 50.9991L136.257 33.9801L144.783 34.9941",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M122.19 32.307L130.716 33.321",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M107.982 39.4611L107.282 45.3721C106.524 45.282 105.791 45.0434 105.125 44.67C104.459 44.2966 103.873 43.7958 103.401 43.196C102.929 42.5962 102.579 41.9092 102.373 41.1744C102.166 40.4395 102.106 39.6712 102.196 38.9131C102.216 38.7361 102.245 38.5611 102.281 38.3901C103.029 34.8441 108.41 35.8621 107.982 39.4611Z",
  fill: "#FFE1B6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M107.28 45.3771C106.522 45.2869 105.789 45.0484 105.123 44.675C104.457 44.3016 103.872 43.8007 103.399 43.2009C102.927 42.6011 102.577 41.9142 102.371 41.1794C102.164 40.4445 102.104 39.6762 102.194 38.9181",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.064 72.9331L101.127 73.9111",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M134.231 51.0131L130.393 51.4861",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.494 44.6571C146.494 44.6571 151.894 69.9571 139.837 76.5931C127.78 83.2291 95.292 74.6661 108.137 43.1041",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M140.619 52.2141C140.743 52.4765 140.797 52.7667 140.776 53.0562C140.754 53.3458 140.658 53.6247 140.496 53.8658C140.334 54.1069 140.112 54.3019 139.853 54.4316C139.593 54.5614 139.304 54.6215 139.014 54.606C136.562 54.855 133.514 49.725 130.083 51.913C130.083 51.913 129.812 48.213 121.777 49.453C113.742 50.693 117.022 45.869 117.022 45.869",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M130.624 55.269C129.889 55.507 129.114 55.5977 128.344 55.5361C127.574 55.4746 126.823 55.2619 126.135 54.9102C125.447 54.5586 124.835 54.0748 124.334 53.4866C123.833 52.8984 123.453 52.2172 123.215 51.4821",
  stroke: "#EE5998",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.977 23.9351C151.977 23.9351 147.743 35.647 123.01 25.449C123.01 25.449 120.683 31.8251 116.244 31.5991C111.805 31.3731 111.465 35.7991 111.465 35.7991",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.603 35.329C147.603 35.329 177.049 15.4671 145.821 10.5701C114.593 5.67307 96.453 13.3791 105.44 36.2331",
  stroke: "#131313",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "cm"
}, /*#__PURE__*/React.createElement("rect", {
  width: 258.11,
  height: 450.471,
  fill: "white"
})));

var SvgCollabMan = function SvgCollabMan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 259,
    height: 451,
    viewBox: "0 0 259 451",
    fill: "none",
    className: "hidden md:block absolute left-0 bottom-0",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCollabMan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CollabMan.2f35c5e0.svg";
export { ForwardRef as ReactComponent };